import { render, staticRenderFns } from "./addCourseKSB.vue?vue&type=template&id=01b8ab99&scoped=true"
import script from "./addCourseKSB.vue?vue&type=script&lang=js"
export * from "./addCourseKSB.vue?vue&type=script&lang=js"
import style0 from "./addCourseKSB.vue?vue&type=style&index=0&id=01b8ab99&prod&lang=less"
import style1 from "./addCourseKSB.vue?vue&type=style&index=1&id=01b8ab99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b8ab99",
  null
  
)

export default component.exports